window.ProgressBar = require('progressbar.js');
window.flatpickr = require('flatpickr');

document.addEventListener("DOMContentLoaded", function (event) {
    // Graphs
    (function() {
        flatpickr('.flatpickr', {dateFormat: "d/m/Y"});

        let graphs = document.getElementsByClassName('cpd-points-snapshot-graph');

        if (graphs.length === 0) {
            return;
        }

        Array.prototype.forEach.call(graphs, function(graph) {
            let bar = new ProgressBar.Circle(graph, {
                strokeWidth: 6,
                easing: 'easeInOut',
                duration: 1400,
                color: graph.dataset.color,
                trailColor: '#d9d9d9',
                trailWidth: 6,
                text: {
                    value: graph.dataset.text
                }
            });

            bar.animate(graph.dataset.progress); // Number from 0.0 to 1.0
        });
    }());

    // Disable submit button on valid CPD hours record submit.
    let cpdSubmitButton = document.querySelector('.js-cpd-submit');
    let cpdForm = document.getElementById('iugo-membership-kiosk-cpd-form');

    if ( cpdForm && cpdSubmitButton  ) {
        cpdForm.noValidate = true;

        cpdForm.addEventListener('submit', function handleFormSubmit(event) {
            const isValid = cpdForm.reportValidity();
            if (isValid) {
                // Form is valid. Prevent duplicate Submit clicks.
                cpdSubmitButton.disabled = 'true';
            } else {
                event.preventDefault();
            }
        });
    }

    // Show the category (e.g. Structured) the chosen activity type counts towards.
    let cpdTypeSelect = document.getElementById('imk_cpd_points_cpd_form_type');
    let cpdTypeCategory = document.querySelector('.js-cpd-type-category');

    if (cpdTypeSelect && cpdTypeCategory) {
        let showCategory = function () {
            let option = cpdTypeSelect.options[cpdTypeSelect.selectedIndex];
            let category = option ? (option.dataset.category || '') : '';

            cpdTypeCategory.textContent = category ? cpdTypeCategory.dataset.label + ': ' + category : '';
            cpdTypeCategory.hidden = !category;
        };

        cpdTypeSelect.addEventListener('change', showCategory);
        showCategory();
    }

    // Member CPD cycle: keep the end date in step with the length and start, and hide it when ongoing.
    let cycleForm = document.querySelector('.js-cpd-cycle');

    if (cycleForm) {
        let lengthSelect = cycleForm.querySelector('.js-cpd-cycle-length');
        let startInput = cycleForm.querySelector('.js-cpd-cycle-start');
        let endInput = cycleForm.querySelector('.js-cpd-cycle-end');
        let endField = cycleForm.querySelector('.js-cpd-cycle-end-field');

        let parseDate = function (value) {
            let match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec((value || '').trim());
            return match ? new Date(+match[3], +match[2] - 1, +match[1]) : null;
        };

        let formatDate = function (date) {
            return String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
        };

        let updateEnd = function () {
            let years = parseInt(lengthSelect.value, 10);
            let ongoing = isNaN(years);

            endField.hidden = ongoing;
            endInput.disabled = ongoing;

            let start = parseDate(startInput.value);

            if (ongoing || !start) {
                return;
            }

            let end = new Date(start.getFullYear() + years, start.getMonth(), start.getDate() - 1);

            if (endInput._flatpickr) {
                endInput._flatpickr.setDate(end, false);
            } else {
                endInput.value = formatDate(end);
            }
        };

        lengthSelect.addEventListener('change', updateEnd);
        startInput.addEventListener('change', updateEnd);
    }
});